var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$i18n.locale === 'ru')?_c('Banner'):_vm._e(),_c('MainMenu'),_c('main',{staticClass:"Main"},[_c('router-view',{key:_vm.$i18n.locale})],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }